import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

function PasswordInput(props) {
    const { intl } = props;
    const [openHelper, setHelperVisibility] = useState(false);
    const [showPassword, updatePasswordVisibility] = useState(false);
    const [passwordHelpers, setHelpers] = useState([
        {
            isReached: false,
            title: 'minLength',
        },
        {
            isReached: false,
            title: 'upperCase',
        },
        {
            isReached: false,
            title: 'lowerCase',
        },
        {
            isReached: false,
            title: 'number',
        },
        {
            isReached: false,
            title: 'specialCharacters',
        },
    ]);
    const { errorMessage, isValid } = props;

    const onBlur = (event) => {
        onChange(event);
        if (props.displayHelper) {
            setHelperVisibility(false);
        }
    };

    const onFocus = () => {
        if (props.displayHelper) {
            setHelperVisibility(true);
        }
    };

    const onChange = (event) => {
        const { value } = event.target;
        const passwordStrengthHelper = [
            {
                isReached: value.length >= 8,
                title: 'minLength',
            },
            {
                isReached: value.match(/[A-Z]/g) !== null,
                title: 'upperCase',
            },
            {
                isReached: value.match(/[a-z]/g) !== null,
                title: 'lowerCase',
            },
            {
                isReached: value.match(/[0-9]/g) !== null,
                title: 'number',
            },
            {
                isReached: value.match(/[!@#$%^&*()_,.<>;'":\\|{[}\]\-?~`/]/g) !== null,
                title: 'specialCharacters',
            },
        ];

        if (event.target.name === 'password') {
            setHelpers(passwordStrengthHelper);
        }

        props.onChange({
            target: {
                isValid: passwordStrengthHelper.every((elem) => elem.isReached),
                name: props.name,
                value,
            },
        });
    };
    return (
        <div className="input-elem-sto password-input">
            <label htmlFor={props.name}>
                <FormattedMessage id={props.label} />
            </label>
            <input
                autoComplete="off"
                className={`input-sto ${isValid === false ? 'hasError ' : 'isValid'}`}
                id={props.name}
                name={props.name}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                placeholder={intl.formatMessage({ id: props.placeholder })}
                required
                type={showPassword ? 'text' : 'password'}
                value={props.value}
            />
            <button
                aria-pressed={showPassword}
                className="input-password-visibility-icon-placeholder"
                onClick={() => updatePasswordVisibility(!showPassword)}
                type="button"
            >
                <Icon
                    aria-label="reveal password" //todo add key for locale
                    type={showPassword ? 'eye-invisible' : 'eye'}
                />
            </button>
            <p
                className={`input-sto-placeholder input-sto-placeholder-error ${
                    errorMessage && props.isValid !== false ? 'hidden' : ''
                }`}
            >
                <FormattedMessage id={errorMessage} />
            </p>

            <div className={`password-helper ${openHelper ? 'open' : 'close'}`}>
                <p>
                    <FormattedMessage id="pages.registration.step2.passwordHelper.title" />
                </p>
                <ul>
                    {passwordHelpers.map((helper, i) => (
                        <li key={`${props.name}-${i}`}>
                            <span className={`password-helper-icon ${helper.isReached ? 'present' : 'missing'}`}>
                                <Icon type={helper.isReached ? 'check-circle' : 'close-circle'} />
                            </span>
                            <FormattedMessage id={`pages.registration.step2.passwordHelper.rules.${helper.title}`} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

PasswordInput.propTypes = {
    displayHelper: PropTypes.bool,
    errorMessage: PropTypes.string,
    isValid: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};

PasswordInput.defaultProps = {
    displayHelper: false,
    isValid: null,
};

export default injectIntl(PasswordInput);
